import React, { useEffect } from 'react';
import { UnverifiedSignupPrompt } from './UnverifiedSignupPrompt';
import { useTrackingContext, trackingContext } from '@jbhi-fi/components/src/Tracking';
import { styles } from './UnverifiedReceiptLanding.css';
import { useReceiptContext } from '../../context/receipt.context';

export type UnverifiedReceiptLandingProps = {
  customerEmail?: string;
  receiptId?: string;
  phoneNumber?: string;
  params?: URLSearchParams;
};

export const UnverifiedReceiptLanding = ({
  customerEmail,
  receiptId,
  phoneNumber,
  params,
}: UnverifiedReceiptLandingProps): JSX.Element => {
  const { trackingData } = useReceiptContext();
  const { tracker } = useTrackingContext();
  const encodedParams = new URLSearchParams(params ?? 'pageTheme=default');
  encodedParams.append('pageTheme', 'default');
  if (receiptId) encodedParams.append('receiptCode', receiptId);
  if (phoneNumber) encodedParams.append('phoneNumber', phoneNumber);

  useEffect(() => {
    tracker.group = 'unclaimed';
    tracker.extraData = {
      ...tracker.extraData,
      purchases: [{ type: 'in-store receipts', receiptId, ...trackingData }],
    };
    tracker.trackView();
  }, []);

  return (
    <div className={styles.container}>
      <UnverifiedSignupPrompt isInline customerEmail={customerEmail} gtmContext={trackingContext.receipts} />
    </div>
  );
};
